import { render } from "./MuseumGroupItem.vue?vue&type=template&id=1f1268e2"
import script from "./MuseumGroupItem.vue?vue&type=script&lang=js"
export * from "./MuseumGroupItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__